import React from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import {
  CREATE_SUBCATEGORY,
  UPDATE_SUBCATEGORY,
} from 'pages/Products/ProductsGraphQL';
import ErrorBoundary from 'components/common/ErrorBoundary';
import {
  getsubCategoryInitialValues,
  subCategoryInitialValues,
  subCategoryValidationSchema,
} from 'pages/Products/constant';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import AddEditSubCategoryForm from './components/AddEditSubCategoryForm';

const AddEditSubCategory = ({ toggleAddRecord, currentRow, type }) => {
  const [createSubCategory] = useMutation(CREATE_SUBCATEGORY, {
    // eslint-disable-next-line no-shadow
    onCompleted: (data) => {
      toast.success(data?.createSubCategory);
      toggleAddRecord();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const [updateSubCategory] = useMutation(UPDATE_SUBCATEGORY, {
    // eslint-disable-next-line no-shadow
    onCompleted: (data) => {
      toast.success(data?.updateSubCategory);
      toggleAddRecord();
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ exception }) => {
        toast.error(exception?.message);
        return exception;
      });
    },
  });

  const handleSubmit = async (values) => {
    if (type === ADD_EDIT_CONSTANT.EDIT) {
      try {
        await updateSubCategory({
          variables: {
            subCategory: {
              // ...values,
              // photo: [values.photo],
              // document: [values.document],
              name: values.name,
              status: values.status,
              id: values.id,
              product: values?.product?.id,
              photo: [values.photo],
              document: [values.document],
              productSubCategory: values?.productSubCategory,
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    } else {
      try {
        await createSubCategory({
          variables: {
            subCategory: {
              // ...values,
              // photo: [values.photo],
              // document: [values.document],
              name: values.name,
              status: values.status,
              product: values?.product?.id,
              photo: [values.photo],
              document: [values.document],
              productSubCategory: values?.productSubCategory,
            },
          },
        });
      } catch (err) {
        toast.error(err);
      }
    }
  };
  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={
            type === ADD_EDIT_CONSTANT.EDIT
              ? getsubCategoryInitialValues(currentRow)
              : subCategoryInitialValues
          }
          enableReinitialize
          validationSchema={subCategoryValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return (
              <AddEditSubCategoryForm
                toggleAddRecord={toggleAddRecord}
                {...props}
                type={type}
              />
            );
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default AddEditSubCategory;
